import styled from 'styled-components';

export const StyledBetslipModal = styled.div`
  background: ${(props) => props.theme.beslip_modal_bg} !important;
`

export const StyledBetslipHead = styled.div`
  background-color: ${(props) => props.theme.betslipHead_BG} !important;
  color: ${(props) => props.theme.betslipHead_text} !important;
`;

export const StyledBetslipCount = styled.div`
  background-color: ${(props) => props.theme.betslipCount_BG} !important;
  color: ${(props) => props.theme.betslipCount_text} !important;
`;

export const StyledBetslipOdds = styled.span`
  color: ${(props) => props.theme.betslipOdds_text} !important;
`;

export const StyledBetslipBonus = styled.div`
  background-color: ${(props) => props.theme.betslipBonus_BG} !important;
  color: ${(props) => props.theme.betslipBonus_text} !important;
`;

export const StyledBetslipStakeBtn = styled.button`
  background-color: ${(props) => props.selected ? props.theme.betslipStakeBtnSelected_BG : props.theme.betslipStakeBtn_BG} !important;
  color: ${(props) => props.selected ? props.theme.betslipStakeBtnSelected_text : props.theme.betslipStakeBtn_text} !important;
  border: 1px solid ${(props) => props.selected ? props.theme.betslipStakeBtnSelected_border : props.theme.betslipStakeBtn_border} !important;
`;

export const StyledPlaceBtn = styled.button`
  background-color: ${(props) => props.theme.betslipPlaceBet_BG} !important;
  color: ${(props) => props.theme.betslipPlaceBet_text} !important;
  border: 1px solid ${(props) => props.theme.betslipPlaceBet_border} !important;
`;

export const StyledModalBtn = styled.button`
  background-color: ${(props) => props.theme.modalBtn_BG} !important;
  color: ${(props) => props.theme.modalBtn_text} !important;
  border: 1px solid ${(props) => props.theme.modalBtn_BG} !important;
`;

export const StyledSignleDeleteIcon = styled.div`
  color: ${(props) => props.theme.signleDeleteIcon} !important;
`;